<template>
  <div :class="{ 'uk-form-controls': !$attrs.placeholder }">
    <select
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      :id="name"
      :value="value"
      :name="name"
      class="uk-select"
      :class="[{ 'uk-form-danger': error }, 'uk-width-' + width]"
    >
    <option value="" disabled>{{ $attrs.placeholder ? $attrs.placeholder : 'Bitte wählen' }}</option>
    <option :value="option" v-for="(option, index) in options" :key="index">{{ option }}</option>
    </select>
    <!--<small v-if="error" class="uk-text-danger">{{ error }}</small>-->
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: ''
    },
    name: {
      required: true,
      Type: String
    },
    options: {
      required: true,
      Type: Array
    },
    width: {
      required: false,
      type: String,
      default: '1-1'
    },
    error: {
      type: String,
      default: null
    }
  },
  components: {
    vSelect
  }
}
</script>
